import app from 'flarum/forum/app';
import DiscussionListSource from './DiscussionListSource';

/** The member's current slug, for the `author` filters, which take slugs. */
export function resolveAuthorSlug(userId) {
  const known = app.store.getById('users', userId);
  return (known ? Promise.resolve(known) : app.store.find('users', userId)).then(user => user.slug());
}

/**
 * Discussions started by one member. The column stores the member's id, not
 * their username, and looks up their current slug when it loads, so renaming
 * the member (or changing the forum's slug driver) doesn't break it.
 */
export default class AuthorDiscussionsSource extends DiscussionListSource {
  constructor(userId) {
    super({
      filter: {}
    });
    this.userId = userId;
  }
  prepare() {
    return resolveAuthorSlug(this.userId).then(slug => {
      this.state.getParams().filter = {
        author: slug
      };
    });
  }
}
flarum.reg.add('flarum-deck', 'forum/columns/AuthorDiscussionsSource', AuthorDiscussionsSource);